import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { DeleteDialog } from "../components";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  advancingTemplateId: number
}

const AdvancingTemplateOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);

  const onDelete = async () => {
    await window.CoreApi.AdvancingTemplate.DeleteTemplate({ advancingTemplateId: props.advancingTemplateId });
    window.location.href = props.listUrl;
  };

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          onClick: () => { setIsDeleting(true); },
          text: RESX.Buttons.btnDelete,
          visible: true,
        }
      ]}
    />
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
  </>;
};

export default AdvancingTemplateOptionsPanel;